//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  OnDestroy,
  Signal,
} from "@angular/core";

//local imports
import { NotificationDismissMessage } from "@app-common/messages/notification-dismiss.message";
import { UserNotificationsDialogModel } from "../../atoms/user-notification-dialog-header/user-notifications-dialog.model";

import { NotificationsStateChangedMessage } from "@core/messages";
import { Messenger } from "@shared/data/messaging/messenger";
import { PresenterType } from "@shared/components/presenter/presenter-type";

@PresenterType({
  model: UserNotificationsDialogModel,
})
@Component({
  selector: 'user-notification-dialog',
  standalone: false,
  templateUrl: './user-notification-dialog.component.html',
  styleUrl: './user-notification-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationDialogComponent implements OnDestroy {
  private notificationStateChanged: Signal<NotificationsStateChangedMessage>;

  public notifications = computed(() => {

    let msg = this.notificationStateChanged();
    if(!msg) return undefined;

    let notifications = msg.notificationState.notifications();
                
    // Sort notifications by utc date in ascending order
    return notifications.sort((a, b) => {
      return (
        new Date(b.createdDate).valueOf() - new Date(a.createdDate).valueOf()
      );
    });
  });

  constructor(private messenger: Messenger) {
    this.notificationStateChanged = this.messenger.getSignal(
      NotificationsStateChangedMessage,
    );
  }

  public deleteNotification(notificationId: string) {
    this.messenger.send(new NotificationDismissMessage(notificationId));
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}